/**
 * Utilitário compartilhado para decidir se uma mensagem do chat
 * pode ser encaminhada (regras espelham o MessageContextMenu e o backend).
 *
 * CHANGELOG:
 *   2026-06-13 v1.0.0 — Extração das regras de elegibilidade para multi-select.
 */

import type { Message } from '@/pages/tenant/Chat';

/** Tipos de mensagem suportados pelo encaminhamento (Fase 1 — WABA). */
export const FORWARDABLE_MESSAGE_TYPES = [
  'text', 'image', 'audio', 'video', 'document', 'location', 'ptv',
] as const;

export interface ForwardableContext {
  /** Se a inbox atual é Instagram (não suporta encaminhamento). */
  isInstagramInbox?: boolean;
}

/**
 * Retorna true quando a mensagem é elegível para encaminhamento.
 * Regras:
 *  - precisa ter external_id (já confirmada no provider)
 *  - não pode ser Instagram
 *  - tipo precisa estar na lista suportada
 *  - não pode estar deletada
 *  - não pode ser mensagem de sistema
 */
export function isMessageForwardable(
  message: Message,
  ctx: ForwardableContext = {},
): boolean {
  if (!message) return false;
  if (message.deleted_at) return false;
  if (message.sender_type === 'system') return false;
  if (!message.external_id) return false;
  if (ctx.isInstagramInbox) return false;
  return (FORWARDABLE_MESSAGE_TYPES as readonly string[]).includes(message.message_type);
}
